export default {
  created () {
    if (this.option) {
      this.option.textStyle = {
        fontFamily: 'Noto Sans SC'
      }
    }
  }
}